module.exports = __webpack_public_path__ + "static_pc/img/32.f8aba545.png";